import { createContext, useContext } from 'react';
const CaseApplicationContext = createContext(null);

export const CaseApplicationProvider = CaseApplicationContext.Provider;

export function useCaseApplication() {
  const caseAppContext = useContext(CaseApplicationContext);
  if (caseAppContext === null) {
    throw new Error('DiggingPermitApp cannot be null, please add the context provider for DiggingPermitApp');
  }
  return caseAppContext;
}
